<template>
  <div id="collect">
    <div class="inner">
      <el-row class="title">
        <el-col :span="24">
          <div class="grid-content bg-purple-dark g-title">我的收藏</div>
        </el-col>
      </el-row>
      <!-- <p class="handleNav">
        <span class="name1">商品信息</span>
        <span class="name2">单价</span>
        <span class="name3">操作</span>
      </p> -->
      <div class="box-content">
        <div class="box-info" v-for="item in data" :key="item.id">
          <router-link
            tag="a"
            target="_blank"
            :to="{ name: 'Detail', params: { id: item.itemId } }"
          >
            <div>
              <img
                v-lazy="item.image"
                alt
                onerror="src='/static/imgout2.png'"
                lazy
              />
            </div>
            <p class="ellipseal" :title="item.itemName">
              <span class="jd" v-show="item.source == 1">优选</span>
              <span class="yx" v-show="item.source == 6">严选</span>
              <span class="new" v-show="item.source == 2">直充</span>
              <span class="rob" v-show="item.source == 3">卡券</span>
              {{ item.itemName }}
            </p>
          </router-link>
          <div class="name2">
            <span class="theme-col" v-if="item.point">
              {{ item.point }} {{ $store.state.name }}
            </span>
            <span v-if="item.point && item.cash">+</span>
            <span class="theme-col" v-if="item.cash">
              {{ item.cash }} 元
            </span>

            <!-- <span style="font-size:12px;text-decoration:line-through;color:#9d9d9d;margin-left: 5px;" v-if="$store.state.webInfo.market_status==1">
              <span>市场价:{{item.market_price}}</span>
              元
            </span> -->
          </div>
          <div class="name3">
            <span size="mini" @click="remove(item.c_id)">取消收藏</span>
          </div>
        </div>
        <div style="clear:both;"></div>
      </div>
      <!-- <ul v-if="data!=''">
        <li v-for="item in data" :key="item.id">
          <router-link tag="a" target="_blank" :to="{name:'Detail',params: {id: item.itemId}}">
            <div class="name1">
              <div class="imgmask" v-show="item.status==0">
                        <div class="no-product">已下架</div>
                      </div>
              <img v-lazy="item.image" alt onerror="src='/static/imgout2.png'" lazy>
              <p class="ellipseal" :title="item.itemName">
                <span class="jd" v-show="item.source==1">优选</span>
                <span class="yx" v-show="item.source==6">严选</span>
                <span class="new" v-show="item.source==2">直充</span>
                <span class="rob" v-show="item.source==3">卡券</span>
                {{item.itemName}}
              </p>
            </div>
          </router-link>
          <div class="name2">
            <span class="theme-col">{{item.point}}</span>
            {{$store.state.name}}
            <span style="font-size:12px;text-decoration:line-through;color:#9d9d9d;margin-left: 5px;" v-if="$store.state.webInfo.market_status==1">
              <span>市场价:{{item.market_price}}</span>
              元
            </span>
          </div>
          <div class="name3">
            <span size="mini" @click="remove(item.c_id)">取消收藏</span>
          </div>
        </li>
      </ul> -->
      <div class="nodatas" v-if="data == ''">
        <img style="width:252px;" src="/static/img/noorder.png" alt />
        <p>暂无数据</p>
        <router-link class="theme-bg" :to="{ name: 'Goodslist' }"
          >随便逛逛</router-link
        >
      </div>
      <!-- 分页 -->
      <div
        style="margin: 15px 0 25px 0;text-align: right"
        class="block"
        v-if="data != '' && count > 20"
      >
        <!-- <el-pagination layout="pager" :total="count" :page-size="5" :current-page.sync="page"></el-pagination> -->
        <el-pagination
          layout="prev,pager, next"
          :total="count"
          :page-size="20"
          :current-page.sync="page"
        ></el-pagination>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      data: "",
      page: 1,
      count: 0
    };
  },
  watch: {
    page(oldV, newV) {
      this.getcollect();
    }
  },
  methods: {
    //获取收藏
    getcollect: function() {
      this.$api.get(
        "user/collection/p_list",
        {
          id_example: this.$store.state.id_example,
          token_user: this.$store.state.user_id,
          pageIndex: this.page
        },
        res => {
          if (res.data.code == 100) {
            this.data = res.data.data.list;
            this.count = res.data.data.count * 5;
            if (res.data.data.list == "" && res.data.data.count != 0) {
              this.page = 1;
              this.getcollect();
            }
          }
        }
      );
    },
    //删除收藏
    remove(id) {
      this.$api.post(
        "user/collection/delete",
        {
          id_example: this.$store.state.id_example,
          token_user: this.$store.state.user_id,
          id_cocollection: id
        },
        res => {
          if (res.data.code == 100) {
            this.getcollect();
            this.$alert("删除成功", "提示", {
              confirmButtonText: "确定",
              callback: action => {}
            });
          }
        }
      );
    }
  },
  mounted() {
    this.getcollect();
  }
};
</script>
<style lang="less" scoped>
/deep/ .el-pager li {
  width: 35px !important;
  height: 35px !important;
  background: #ffffff !important;
  border-radius: 3px !important;
  border: 1px solid #e7e7e7 !important;
  margin: 0px 2.5px !important;
}
/deep/ .el-pagination .btn-next,
/deep/.el-pagination .btn-prev {
  width: 35px !important;
  height: 35px !important;
  background: #ffffff !important;
  border-radius: 3px !important;
  border: 1px solid #e7e7e7 !important;
  margin: 0px 2.5px !important;
}
/deep/ .el-pager li.active {
  color: #e53940 !important;
  background: rgba(229, 57, 64, 0.1) !important;
  border: 1px solid #e53940 !important;
}
.box-content {
  margin-top: 20px;
  .box-info {
    float: left;
    position: relative;
    width: 220px;
    height: 314px;
    margin-right: 10px;
    background: #ffffff;
    border: 1px solid #dbdbdb;
    padding: 10px;
    box-sizing: border-box;
    height: 314px;
    overflow: hidden;
    margin-bottom: 15px;
    &:nth-child(4n) {
      margin-right: 0px;
    }
    .ellipseal {
      font-size: 14px;
      font-family: MicrosoftYaHei;
      color: #272727;
      line-height: 24px;
      height: 48px;
      margin-top: 5px;
      margin-bottom: 10px;
    }
    .name2 {
      height: 21px;
      font-size: 16px;
      font-family: MicrosoftYaHei;
      color: #e53940;
      line-height: 21px;
    }
    .name3 {
      width: 220px;
      height: 39px;
      left: 0;
      text-align: center;
      line-height: 39px;
      bottom: -40px;
      position: absolute;
      background: rgba(38, 38, 38, 0.6);
      transition: bottom 0.25s ease;
      span {
        color: #fff;
      }
    }
    &:hover {
      .name3 {
        bottom: 0px;
      }
    }
  }
}
#collect {
  width: 985px;
  min-height: 572px;
  float: left;
  background: #fff;
  box-shadow: 0px 9px 13px 0px rgba(190, 190, 190, 0.2);
  .g-title {
    height: 40px;
    font-size: 24px;
    font-family: MicrosoftYaHei;
    color: #262626;
    line-height: 40px;
    border-bottom: dashed 1px rgba(151, 151, 151, 0.5);
    padding-bottom: 8px;
  }
  .inner {
    box-sizing: border-box;
    padding: 10px 30px;
  }
  .handleNav {
    height: 40px;
    background: #e3e3e3;
    border: 1px solid #ddd;
    border-bottom: none;
    margin-top: 55px;
    background-color: #f3f3f3;
    span {
      display: inline-block;
      height: 40px;
      line-height: 40px;
      text-align: center;
      color: #353535;
    }
    .name1 {
      width: 370px;
      margin-left: 20px;
      text-align: left;
    }
    .name2 {
      width: 260px;
    }
    .name3 {
      width: 260px;
    }
  }
  ul {
    border: 1px solid #e3e3e3;
    border-top: none;
    li {
      overflow: hidden;
      height: 125px;
      .ellipseal {
        color: #5c5c5c;
      }
      div {
        float: left;
        height: 125px;
        box-sizing: border-box;
        padding: 20px 0;
        overflow: hidden;
        img {
          width: 90px;
          height: 90px;
          float: left;
        }
        p {
          margin: 20px 0 0 27px;
          float: left;
          width: 250px;
        }
      }
      .name1 {
        width: 370px;
        margin-left: 20px;
      }
      .name2 {
        color: #868686;
        width: 270px;
        text-align: center;
        line-height: 85px;
      }
      .name3 {
        width: 270px;
        text-align: center;
        line-height: 85px;
      }
    }
  }
  .nodatas {
    width: 252px;
    margin: auto;
    text-align: center;
    height: 400px;
    img {
      margin-top: 110px;
    }
    p {
      margin: 15px 0;
    }
    a {
      display: inline-block;
      width: 140px;
      height: 35px;
      text-align: center;
      line-height: 35px;
      border-radius: 30px;
      font-size: 14px;
    }
  }
  .imgmask {
    width: 90px;
    height: 90px;
    position: absolute;
    background: #333;
    z-index: 99;
    opacity: 0.5;
  }
  .no-product {
    line-height: 90px;
    font-size: 12px;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    color: #fff;
    border-radius: 46px;
    text-align: center;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/user/cont/mycollect.vue